import { api } from '@/integrations/clients/carAuction/carAuctionClient';
import { Company, CreateCompanyRequest, CreateCompanyResponse } from '@/types/company';

export class CompanyService {
  // Get company by organization number (primary use case for registration)
  static async getCompanyByOrgNumber(orgNumber: string): Promise<Company | null> {
    try {
      const response = await api.get<{
        success: true;
        data: Company;
      }>(`/companies/by-org-number/${encodeURIComponent(orgNumber)}`);
      
      return response.data;
    } catch (error: any) {
      // Return null if company not found (404)
      // ApiError format: { message, status, details }
      // Check both ApiError format and axios error format
      const status = error?.status || error?.response?.status;
      if (status === 404) {
        return null;
      }
      throw error;
    }
  }

  // Create a new company (public use - for registration)
  static async createCompany(data: CreateCompanyRequest): Promise<CreateCompanyResponse> {
    const response = await api.post<{
      success: true;
      data: Company;
    }>('/companies', data);
    
    return {
      id: response.data._id,
      status: 'success',
      message: '', // Message is handled by i18n in UI components
      createdAt: response.data.created_at,
    };
  }
}
